import { useState, useCallback } from "react";

export function useModal() {
  const [modal, setModal] = useState({
    isOpen: false,
    title: null,
    message: "",
    type: "info",
    onConfirm: null,
    confirmText: "OK",
    cancelText: "Cancel",
    showCancel: false
  });

  const showModal = useCallback((options) => {
    setModal({
      isOpen: true,
      title: options.title || null,
      message: options.message || "",
      type: options.type || "info",
      onConfirm: options.onConfirm || null,
      confirmText: options.confirmText || "OK",
      cancelText: options.cancelText || "Cancel",
      showCancel: options.showCancel || false
    });
  }, []);

  const hideModal = useCallback(() => {
    setModal(prev => ({ ...prev, isOpen: false }));
  }, []);

  const showAlert = useCallback((message, type = "info", title = null) => {
    showModal({ message, type, title, showCancel: false });
  }, [showModal]);

  const showConfirm = useCallback((message, onConfirm, title = "Confirm", type = "warning") => {
    showModal({
      message,
      type,
      title,
      onConfirm,
      showCancel: true,
      confirmText: "Confirm",
      cancelText: "Cancel"
    });
  }, [showModal]);

  return {
    modal,
    showModal,
    hideModal,
    showAlert,
    showConfirm
  };
}

